import Vue from 'vue'
import Vuex from 'vuex'

import admin from './modules/admin'
import colors from './modules/colors'
import copy from './modules/copy'
import header from './modules/header'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import profile from './modules/profile'
import usuarios from './modules/usuarios'
import info from './modules/info'
import suscripciones from './modules/suscripciones'
import products from './modules/products'
import contacto from './modules/contacto'
import descuento from './modules/descuento'
import banner from './modules/banner'
import vendidosgen from './modules/vendidosgen'
import vendidosmcf from './modules/vendidosmcf'
import distribuidores from './modules/distribuidores'
import client from './modules/client'
import supliers from './modules/supliers'
import quotations from './modules/quotations'
import units from './modules/units'
import currency from './modules/currency'
import template from './modules/template'
import status from './modules/status'
import orders from './modules/orders'
import paqueterias from './modules/paqueterias'
import clientToUpdate from './modules/clientToUpdate'
import notification from './modules/notification'
import estadisticas from './modules/estadisticas'
import plots from './modules/plots'
import related from './modules/related'
import categorias from './modules/categorias'
import subcategorias from './modules/subcategorias'
import generate from './modules/generate'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin: admin,
    colors:colors,
    copy:copy,
    header:header,
    logo:logo,
    main: main,
    mainmtr:mainmtr,
    profile:profile,
    usuarios: usuarios,
    info: info,
    suscripciones: suscripciones,
    products: products,
    contacto,
    descuento,
    banner,
    vendidosgen,
    vendidosmcf,
    distribuidores,
    client,
    supliers,
    quotations,
    units,
    currency,
    template,
    status,
    orders,
    paqueterias,
    clientToUpdate,
    notification,
    estadisticas,
    plots,
    related,
    categorias,
    subcategorias,
    generate
  }
})
